import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AutoRedemptionSettingType } from '@rd/types/auto-redemption-setting.type';
import * as autoRedemptionSettingsView from '../actions/auto-redemption-settings-view.actions';

export interface IAutoRedemptionSettingsViewFacade {
  enterDetailsPage(autoRedemptionSettingType: AutoRedemptionSettingType): void;
  enterReviewPage(autoRedemptionSettingType: AutoRedemptionSettingType): void;
  enterSuccessPage(autoRedemptionSettingType: AutoRedemptionSettingType): void;
}

@Injectable({ providedIn: 'root' })
export class AutoRedemptionSettingsViewFacade
  implements IAutoRedemptionSettingsViewFacade
{
  constructor(private store: Store) {}

  enterDetailsPage(
    autoRedemptionSettingType: AutoRedemptionSettingType,
    isEverydaySpend = false,
  ): void {
    this.store.dispatch(
      autoRedemptionSettingsView.AutoRedemptionSettingsViewEnterDetailsPage({
        autoRedemptionSettingType,
        isEverydaySpend,
      }),
    );
  }

  enterReviewPage(
    autoRedemptionSettingType: AutoRedemptionSettingType,
    isEverydaySpend = false,
  ): void {
    this.store.dispatch(
      autoRedemptionSettingsView.AutoRedemptionSettingsViewEnterReviewPage({
        autoRedemptionSettingType,
        isEverydaySpend,
      }),
    );
  }

  enterSuccessPage(
    autoRedemptionSettingType: AutoRedemptionSettingType,
    isEverydaySpend = false,
  ): void {
    this.store.dispatch(
      autoRedemptionSettingsView.AutoRedemptionSettingsViewEnterSuccessPage({
        autoRedemptionSettingType,
        isEverydaySpend,
      }),
    );
  }
}
